import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  TABLE_DATA,
  TABLE_HEADERS,
  keyMapping,
  topDataList,
  topDataListOut
} from "../../../../constants/SalesQuotationApprovalList";

// import ListPage from "../Shared/ListPage";
import ROUTES_NAVIGATION from "../../../../routes/routes";
import ListPage from "../../Sales/Shared/ListPage";
import axiosInstance from "../../../services/api/API";
import Loader from "../../../customComponents/CustomLoader";


const StockOut = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const token = localStorage.getItem("authToken");
  const [ stockinData, setStockinData ] = useState([]) 
  const [loading, setLoading] = useState(true);
  const [searchQuery,setSearchQuery] = useState("")


  useEffect(() => {
    fetchPoStockout()
  },[])

  const fetchPoStockout = async (page = 0, pageSize = 10) => {
    try{
      setLoading(true)
      const response = await axiosInstance.post("/postockoutdetail/list",{  orderBy: 'po_id desc',
        page,
        pageSize,
      searchText:searchQuery}, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      })

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        // "Sr No.": index + 1 + page * pageSize
      }));
      const totalRecordsData = response?.data?.data?.totalRecords
      setTotalRecords(totalRecordsData);
      setStockinData(formattedData)
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));

    }catch(error){
      console.log(error)
    }
    finally{
      setLoading(false)
    }
  }
  // navigate to stockout details

  const handleViewDetails = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.STOCKOUTDETAILS}`, { state: { data: rowData } });
  }
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      apiCallFunction(0, 10,searchQuery); 
    }
  }  
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const apiCallFunction = () =>{
    fetchPoStockout()
  }

  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
      <div>
    <ListPage
      isButtonRequired={false}
      headerTopText="Logistics / Stock Out"
      headerTitle="Stock Out"
      listTitle="All Stock Out"
      topDetailsList={topDataListOut}
      tableData={stockinData}
      tableHeaders={TABLE_HEADERS}
      keyMapping={keyMapping}
      handleViewButton={handleViewDetails}
      itemsPerPage={10}
      currentPage={currentPage}
      totalPages={totalPages}
      totalRecords={totalRecords} 
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      handleSearchChange={handleSearchChange}
      handleKeyPress={handleKeyPress} 
      apiCallFunction={apiCallFunction}
      searchplaceholder="Search By PO Type"
    />
              </div>
    )}
    </div>
  );
};

export default StockOut;
